import { html } from 'lit';
const Data2Panel =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M11.53 10.588c4.158 0 7.529-1.475 7.529-3.294 0-1.82-3.371-3.294-7.53-3.294C7.371 4 4 5.475 4 7.294c0 1.82 3.371 3.294 7.53 3.294m6.804 0c-1.208 1.113-3.801 1.883-6.805 1.883s-5.596-.77-6.804-1.883C4.26 11.016 4 11.495 4 12c0 1.82 3.371 3.294 7.53 3.294 4.158 0 7.529-1.475 7.529-3.294 0-.505-.26-.984-.725-1.412m0 4.706c-1.208 1.113-3.801 1.883-6.805 1.883s-5.596-.77-6.804-1.883c-.465.428-.725.907-.725 1.412C4 18.526 7.371 20 11.53 20c4.158 0 7.529-1.475 7.529-3.294 0-.505-.26-.984-.725-1.412" clip-rule="evenodd"/>
  </svg>
`;
export default Data2Panel;
